export type DismissInteraction = 'esc' | 'interact-outside';

export type DisableDismissOption = '*' | DismissInteraction | DismissInteraction[];

export interface DismissableProps {
  disableDismissOn?: DisableDismissOption;
}

export interface UseDismissHandlerReturn {
  handleDismissInteraction: (interaction: DismissInteraction, event: Event) => boolean;
}

interface UseDismissHandlerOptions {
  disableDismissOn?: DisableDismissOption | undefined;
}

export const useDismissHandler = (options: UseDismissHandlerOptions): UseDismissHandlerReturn => {
  const handleDismissInteraction = (interaction: DismissInteraction, event: Event) => {
    const target = event.target as HTMLElement;
    if (
      target?.closest('[data-sonner-toaster]') ||
      target?.closest('#stream-markdown-overlay') ||
      target?.closest('#vg-tooltip-element')
    ) {
      event.preventDefault();
      return false;
    }

    if (
      options.disableDismissOn === interaction ||
      (Array.isArray(options.disableDismissOn) && options.disableDismissOn.includes(interaction))
    ) {
      event.preventDefault();
      return false;
    }
    return true;
  };

  return { handleDismissInteraction };
};
